import { Icons } from '@Assets/SvgIcons';
import { ICTask } from '@Helper/Interfaces';
import { MergefloColors } from '@Helper/MergefloColors';
import { getAssets } from '@Store/feature/assetsSlice';
import { getPurePlaybookList } from '@Store/feature/purePlaybookSlice';
import { selectedTaskDetailUpdate } from '@Store/feature/taskSlice';
import { useAppDispatch, useAppSelector } from '@Store/hooks';
import DataGrid, {
  Column,
  SearchPanel,
  Selection,
} from 'devextreme-react/data-grid';
import React, { FC, useEffect, useState } from 'react';
import CountdownCel from './Cell/CountdownCel';
import DueDateCell from './Cell/DueDateCell';
import OperationCell from './Cell/OperationCell';
import RidCell from './Cell/RidCell';
import TaskNumberCell from './Cell/TaskNumberCell';
import UserCell from './Cell/UserCell';
import classes from './TodoTable.module.css';
import { Tooltip } from '@mui/material';

type IProps = {
  taskList: ICTask[];
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
  searchString?: string;
  editable?: boolean;
};

const DependencyTable: FC<IProps> = ({
  taskList,
  updateTaskProperty,
  searchString,
  editable,
}) => {
  const dispatch = useAppDispatch();
  const purePlaybooks = useAppSelector(getPurePlaybookList);

  const mergefloColors = new MergefloColors();

  const [expandedRowKeys, setexpandedRowKeys] = useState<string[]>(
    taskList
      ?.filter(item => item.isCompleted)
      ?.map(item => {
        return item.id;
      }) as string[]
  );

  useEffect(() => {
    const list = taskList
      ?.filter(item => item.isCompleted)
      ?.map(item => {
        return item.id;
      }) as string[];
    setexpandedRowKeys(list ?? []);
  }, [taskList]);

  const onRowClick = (e: any) => {
    const data = {
      selectedTask: e.data,
      isShowTaskModal: true,
    };
    dispatch(selectedTaskDetailUpdate(data));
  };

  const DependencyItem = (t: any) => {
    return (
      <div
        style={{
          backgroundColor:
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencySource
            )?.project.isDeleted ??
              false) ||
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencyTarget
            )?.project.isDeleted ??
              false)
              ? '#E0DFE6'
              : mergefloColors.getPlaybookColor(
                  purePlaybooks?.find(
                    i => i.functionalAreaId === t.data.dependencyTarget
                  )?.project.taskPrefix ?? ''
                ),
          borderRadius: '100px',
          border: 2,
          borderColor:
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencySource
            )?.project.isDeleted ??
              false) ||
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencyTarget
            )?.project.isDeleted ??
              false)
              ? '#DE3506'
              : '#ffffff',
          padding: '3px 8px',
          marginRight: 10,
          fontSize: 11,
          fontWeight: 600,
          color:
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencySource
            )?.project.isDeleted ??
              false) ||
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencyTarget
            )?.project.isDeleted ??
              false)
              ? '#DE3506'
              : '#ffffff',
          textAlign: 'center',
          display: 'inline-block',
        }}
      >
        <span
          style={{
            marginRight: 5,
          }}
        >
          {
            purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencySource
            )?.project.taskPrefix
          }
          {purePlaybooks?.find(
            f => f.functionalAreaId === t.data.dependencySource
          )?.project.isDeleted ?? false
            ? ' deleted '
            : ''}
        </span>
        <Icons.ArrowDown
          color={
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencySource
            )?.project.isDeleted ??
              false) ||
            (purePlaybooks?.find(
              f => f.functionalAreaId === t.data.dependencyTarget
            )?.project.isDeleted ??
              false)
              ? '#DE3506'
              : '#ffffff'
          }
        />
        <span
          style={{
            marginLeft: 5,
          }}
        >
          {purePlaybooks?.find(
            f => f.functionalAreaId === t.data.dependencyTarget
          )?.project.taskPrefix ?? ''}{' '}
          {purePlaybooks?.find(
            f => f.functionalAreaId === t.data.dependencyTarget
          )?.project.isDeleted ?? false
            ? ' deleted '
            : ''}
        </span>
      </div>
    );
  };

  const renderRidCell = (data: any) => {
    if (data.data.column.dataField === 'subTaskCount') {
      return (
        <div className={classes.ridDiv}>
          {data.data.text > 0 && (
            <Tooltip title="Subtasks">
              <div className={classes.svgIcon}>
                <Icons.SubTaskIcon color="#7D7A9A" /> {data.data.text}
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    if (data.data.column.dataField === 'riskCount') {
      return (
        <div className={classes.ridDiv}>
          {data.data.text > 0 && (
            <Tooltip title="Risk Count">
              <div className={classes.svgIcon}>
                <Icons.Risks20 color="#7D7A9A" /> {data.data.text}
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    if (data.data.column.dataField === 'decisionCount') {
      return (
        <div className={classes.ridDiv}>
          {data.data.text > 0 && (
            <Tooltip title="Decision Count">
              <div className={classes.svgIcon}>
                <Icons.Decision20 color="#7D7A9A" /> {data.data.text}
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    if (data.data.column.dataField === 'issueCount') {
      return (
        <div className={classes.ridDiv}>
          {data.data.text > 0 && (
            <Tooltip title="Issue Count">
              <div className={classes.svgIcon}>
                <Icons.Issues20 color="#7D7A9A" /> {data.data.text}
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    if (data.data.column.dataField === 'dependenciesCount') {
      return (
        <div className={classes.ridDiv}>
          {data.data.text > 0 && (
            <Tooltip title="Dependency Count">
              <div className={classes.svgIcon}>
                <Icons.Dependency color="#7D7A9A" /> {data.data.text}
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    if (data.data.column.dataField === 'hasDescription') {
      return (
        <div className={classes.ridDiv}>
          {data.data.data.hasDescription && (
            <Tooltip title="Description Entered">
              <div className={classes.svgIcon}>
                <Icons.Description color="#7D7A9A" />
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    if (data.data.column.dataField === 'attachmentCount') {
      return (
        <div className={classes.ridDiv}>
          {data.data.text > 0 && (
            <Tooltip
              title={
                data.data.text + ' Attachment' + (data.data.text > 1 ? 's' : '')
              }
            >
              <div className={classes.svgIcon}>
                <Icons.Attachment color="#7D7A9A" />
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    if (data.data.column.dataField === 'commentCount') {
      return (
        <div className={classes.ridDiv}>
          {data.data.text > 0 && (
            <Tooltip
              title={
                data.data.text + ' Comment' + (data.data.text > 1 ? 's' : '')
              }
            >
              <div className={classes.svgIcon}>
                <Icons.Comment color="#7D7A9A" />
              </div>
            </Tooltip>
          )}
        </div>
      );
    }
    return <></>;
  };

  return (
    <div>
      {' '}
      <DataGrid
        dataSource={taskList}
        keyExpr="id"
        showRowLines={true}
        showBorders={true}
        //parentIdExpr="parentId"
        selectedRowKeys={expandedRowKeys}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        className={[classes.table, 'todoCardTreeList'].join(' ')}
        onRowDblClick={onRowClick}
        autoNavigateToFocusedRow={false}
        onSelectionChanged={e => {
          console.log('onRowExpanded', e);
          if (e.currentSelectedRowKeys[0]) {
            const currentTask = taskList?.find(
              item => item.id === e.currentSelectedRowKeys[0].toString()
            );
            if (currentTask && currentTask.id && updateTaskProperty) {
              updateTaskProperty(currentTask.id, 'isCompleted', true);
            }
          }
          if (e.currentDeselectedRowKeys[0]) {
            const currentTask = taskList?.find(
              item => item.id === e.currentDeselectedRowKeys[0].toString()
            );
            if (currentTask && currentTask.id && updateTaskProperty) {
              updateTaskProperty(currentTask.id, 'isCompleted', false);
            }
          }
        }}
      >
        <SearchPanel visible={false} text={searchString} />
        <Column
          dataField="taskNumber"
          width={30}
          caption=""
          cellComponent={e => (
            <TaskNumberCell
              task={e.data.data}
              updateTaskProperty={updateTaskProperty}
              showTaskName={false}
              disabled={!editable}
            />
          )}
          allowEditing={false}
          allowSorting={false}
        />

        <Column
          dataField="name"
          caption=""
          cellComponent={(data: any) => (
            <div
              className={[
                data.data.data.isCompleted ? classes.completed : '',
                classes.taskNameEllipsis,
              ].join(' ')}
            >
              {data.data.data.name === ' '
                ? '(' +
                  (purePlaybooks?.find(
                    f => f.functionalAreaId === data.data.data.dependencySource
                  )?.project.taskPrefix ?? '') +
                  ' - ' +
                  (purePlaybooks?.find(
                    f => f.functionalAreaId === data.data.data.dependencyTarget
                  )?.project.taskPrefix ?? '') +
                  ')' +
                  (data.data.data.parentTaskName ?? '')
                : data.data.data.name}
            </div>
          )}
        />
        <Column
          dataField="subTaskCount"
          caption=""
          cellComponent={renderRidCell}
          allowEditing={false}
          width={53}
        />
        <Column
          dataField="riskCount"
          caption=""
          cellComponent={renderRidCell}
          allowEditing={false}
          width={53}
        />
        <Column
          dataField="issueCount"
          caption=""
          cellComponent={renderRidCell}
          allowEditing={false}
          width={53}
        />
        <Column
          dataField="decisionCount"
          caption=""
          cellComponent={renderRidCell}
          allowEditing={false}
          width={53}
        />

        <Column
          dataField="dependenciesCount"
          caption=""
          cellComponent={renderRidCell}
          allowEditing={false}
          width={53}
        />
        <Column
          dataField="hasDescription"
          caption=""
          cellComponent={renderRidCell}
          allowEditing={false}
          width={32}
        />

        <Column
          dataField="commentCount"
          caption=""
          cellComponent={renderRidCell}
          width={32}
          allowEditing={false}
        />
        <Column
          dataField="attachmentCount"
          caption=""
          cellComponent={renderRidCell}
          width={32}
          allowEditing={false}
        />
        <Column
          dataField="dependency"
          caption=""
          cellComponent={(data: any) => (
            <div style={{ textAlign: 'center' }}>
              <DependencyItem data={data.data.data} />
            </div>
          )}
          width={190}
          allowEditing={false}
        />
        <Column
          dataField="dueDate"
          caption="Due date"
          dataType="date"
          cellComponent={(data: any) => (
            <DueDateCell
              data={data}
              updateTaskProperty={updateTaskProperty}
              editable={editable}
            />
          )}
          width={120}
          allowEditing={false}
        />
        <Column
          dataField="dueDate"
          dataType="date"
          caption="Countdown"
          cellComponent={(data: any) => <CountdownCel data={data} />}
          width={100}
          allowEditing={false}
        />
        <Column
          dataField="assignee"
          caption="Assignee"
          cellComponent={(data: any) => (
            <UserCell
              data={data}
              updateTaskProperty={updateTaskProperty}
              editable={editable}
            />
          )}
          width={80}
          allowEditing={false}
        />

        <Column
          dataField="operation"
          caption=""
          cellComponent={(data: any) => (
            <OperationCell
              data={data}
              updateTaskProperty={updateTaskProperty}
            />
          )}
          width={50}
          allowEditing={false}
        />
      </DataGrid>
    </div>
  );
};

export default DependencyTable;
